export const MemShareConstant = {
    FEED_REQUEST: 'FEED_MEMSHARE_REQUEST',
    FEED_SUCCESS: 'FEED_MEMSHARE_SUCCESS',
    FEED_FAILURE: 'FEED_MEMSHARE_FAILURE',
}
